import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import fetch, { update } from '../../../Api/definitionCourseJobTitle';

/**
 * Carga los cursos del puesto y guarda cuáles quedan asignados.
 *
 * `coursesByEnterprise` y `coursesByDepartment` no se definen aquí: son los que
 * el empleado ya arrastra por su empresa y su departamento, y viajan solo para
 * mostrarlos.
 *
 * @param {{departmentId: string, jobTitleId: string}} params - Puesto en edición.
 * @param {Function} setIsLoading - Apaga el indicador de carga de la tabla.
 */
const useCourse = ({ departmentId, jobTitleId }, setIsLoading) => {
  const history = useHistory();
  const [courses, setCourses] = useState([]);
  const [coursesByEnterprise, setCoursesByEnterprise] = useState([]);
  const [coursesByDepartment, setCoursesByDepartment] = useState([]);
  const [defaultSelectedIds, setDefaultSelectedIds] = useState([]);
  const [terminals, setTerminals] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let isMounted = true;

    fetch(departmentId, jobTitleId).then(data => {
      if (!isMounted) return;

      setCourses(data.courseByJobTitle);
      setCoursesByDepartment(data.courseByDepartment);
      setCoursesByEnterprise(data.courseByEnterprise);
      setCategories(data.categories);
      setTerminals(data.terminals);
      setDefaultSelectedIds(data.courseByJobTitle.filter(course => course.isChecked).map(course => course.id));
      setIsLoading(false);
    });

    return () => {
      isMounted = false;
    };
  }, []);

  /**
   * Guarda la diferencia y vuelve al hub, que anuncia el éxito.
   *
   * @param {{id: string, value: boolean}[]} courseData - Cursos a marcar o desmarcar.
   */
  const saveCourses = courseData => {
    update(courseData, jobTitleId)
      .then(() => {
        history.push({
          pathname: '/definicion',
          state: {
            update: true,
          },
        });
      })
      .catch(err => err);
  };

  return {
    courses,
    terminals,
    categories,
    saveCourses,
    coursesByEnterprise,
    coursesByDepartment,
    defaultSelectedIds,
  };
};

export default useCourse;
